/**
*
*   Intercom Messenger
*       - Manages the Intercom Chat on the Website
*
**/
'use client';

import Intercom from '@intercom/messenger-js-sdk';
import { useContext, useEffect } from 'react';
import { useSession } from 'next-auth/react';
import { CustomerContext } from '@/context/customer';
import moment from 'moment-timezone';

/**
*
*
*
**/
export default function Messenger({ children, ...props }){

	//The Session
	const { data: session, status } = useSession();
	const { Customer } = useContext(CustomerContext);

	//Load the Customer
	const customer = Customer.get( customer => customer );

	//Update Intercom when the Customer email changes
	useEffect(()=>{
		(async ()=>{

			//The Intercom Data
			let data = {
				app_id: process.env.NEXT_PUBLIC_INTERCOM_APPID,
				name:   null,
				email:  null
			};

			//If we have a customer
			if( customer && customer?.email ){

				//Load the Intercom User Hash
				const response = await (
					await fetch( '/api/intercom' , {
						method: 'POST',
						headers: {},
						body:   JSON.stringify({
							email:  customer.email
						})
					})
				).json();

				//Add the Data
				data = Object.assign(data,{
					user_id:    customer.id.match(/Customer\/([0-9]+)/)[1],
					name:       Customer.getDisplayName(),
					email:      customer.email,
					created_at: moment( customer.created_at ).unix(),
					user_hash:  response.hash
				});

			}

			//Load Intercom
			Intercom(data);

		})();
	},[ customer?.email ]);


	//Return
	return children;

}